import React, {useState} from "react";
import * as palette from "../Variables";
import styled from "styled-components";

const StyledWorkHero = styled.div`
    width: 100%;
    height: 260px;

    @media (min-width: 768px) {
        height: 400px;
    }

    img {
        object-fit: cover;
        height: 100%;
    }
`;

const WorkHero = ({src, alt, className}) => {
    return (
        <StyledWorkHero className={className}>
            <img src={src} alt={alt}/>
        </StyledWorkHero>
    )
}

export default WorkHero;